import React, { useState, useEffect, useRef } from "react";
import PDIAssignmentModal from "./PDIAssignmentModal.jsx";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { CloudDownload, PictureAsPdf, CloudUpload } from "@mui/icons-material"; // Import the PDF icon
import { jsPDF } from "jspdf"; // jsPDF library to generate PDF
import PDIApprovalDialog from "./PdiApprovalDialog";
import styles from "../../../styles/adminPortal.module.css";
import Chip from "@mui/material/Chip";
import FormatTimestamp from "../../../helperFunctions/FormatDateTimestamp";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { MoreVert } from "@mui/icons-material";
import BlockIcon from "@mui/icons-material/Block";
import FilePreviewModal from "../../../shared/utils/FilePreviewModal.jsx";
import GlobalButton from "../../../shared/utils/GlobalButton";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Tooltip,
  Avatar,
  AvatarGroup,
  Modal,
  CloseIcon,
} from "@mui/material";
import { CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import Styles from "../../../styles/vendorDashboard.module.css";
import FormatDateTimestamp from "../../../helperFunctions/FormatDateTimestamp";
import PDIRejectedDialog from "./pdiRejectedDialog";
import Swal from "sweetalert2";
import PDIReasonDialog from "./PDIReasonDialog.js";
import Close from "@mui/icons-material/Close";
import {
  NewPlusIcon,
  PlusIconSVG,
} from "../../../shared/assets/icons/index.js";
import ProductMediaModal from "./PdiDocumentsViewer.js";
// import plusIcon from "../../../shared/assets/icons/";

const headCells = [
  {
    id: "campaignTitle",
    label: "Campaign Title",
    width: 180,
  },

  {
    id: "batchID",
    label: "Batch Details",
    width: 140,
  },
  {
    id: "pdiDate",
    label: "PDI Date",
    width: 100,
  },

  {
    id: "vendorDetails",
    label: "Vendor Details",
    width: 200,
  },

  {
    id: "checkList",
    label: "Checklist",
    width: 100,
  },
  {
    id: "media",
    label: "Media",
    width: 200,
  },
  {
    id: "pdiAssignedTo ",
    label: "PDI Assigned To",
    width: 200,
  },
  {
    id: "pdiStatus",
    label: "PDI Status",
    width: 140,
  },
  {
    id: "pdiDoneBy",
    label: "PDI Done By",
    width: 160,
  },
  {
    id: "uploadDocument",
    label: "Upload Document",
    width: 160,
  },
];

function EnhancedTableHead(props) {
  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className="absolute top-2"> {headCell.label} </span>
            <div className={styles.topBorderDiv}>
              {["campaignTitle"].includes(headCell.id) && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder={`Search...`}
                  onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                  value={props.searchInputs?.[headCell.id] || ""} // Access search inputs from props
                />
                // <input
                //   type="text"
                //   className="px-3 w-full py-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 mt-2"
                //   placeholder={`Search ${headCell.id}`}
                //   onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                //   value={props.searchInputs?.[headCell.id] || ""} // Access search inputs from props
                // />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className="border-b flex justify-between items-center h-14 pt-2">
      {!isMobile && (
        <div className="font-bold text-md text-gray-600">
          Total PDI: {props.totalInstallationPartner}
        </div>
      )}

      {isMobile && (
        <div className="flex justify-between items-center w-full">
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="p"
            id="tableTitle"
            component="div"
          >
            Total PDI: {props.totalInstallationPartner}
          </Typography>
        </div>
      )}
    </div>
  );
}

export default function EnhancedTable() {
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  const [PDI, setPDI] = useState([]);
  const [isMediaModalOpen, setIsMediaModalOpen] = useState(false);
  const [selectedProductMedia, setSelectedProductMedia] = useState([]);
  const [installationPartnerListLoading, setInstallationPartnerLoading] =
    useState(true);
  const [totalInstallationPartner, setTotalInstallationPartner] = useState("0");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [checkListOpenModal, setCheckListOpenModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(null);
  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  const [searchInputs, setSearchInputs] = useState({
    campaignTitle: "",
  });
  const [keyAccountManagers, setKeyAccountManagers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFileOpen, setIsFileOpen] = useState(false);

  const [reasonDialogOpen, setReasonDialogOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const [selectedFiles, setSelectedFiles] = useState({}); // Store files by ID
  const fileInputRef = useRef({}); // Store refs dynamically
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const token = localStorage.getItem("token");

  // Fetch key account managers
  const fetchKeyAccountManagers = async () => {
    try {
      setUsersLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/users/key-account-managers`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setKeyAccountManagers(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching key account managers:", error);
    } finally {
      setUsersLoading(false);
    }
  };

  const getPDITableData = async (page = 1, limit = 20) => {
    try {
      const response = await axios.get(
        `${serverURL}/PDI?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setTotalInstallationPartner(response?.data?.total);
        setTotalPages(response?.data?.totalPages);
        setPDI(response?.data?.data);
        setInstallationPartnerLoading(false);
        setPage(response?.data?.currentPage);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    }
  };

  useEffect(() => {
    // Fetch both PDI data and key account managers when component mounts
    const fetchData = async () => {
      setInstallationPartnerLoading(true);
      await Promise.all([
        fetchKeyAccountManagers(),
        getPDITableData(page, pageSize),
      ]);
    };
    fetchData();
  }, []);

  const handlePageChange = async (e, value) => {
    setPage(value); // Update the page state

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    queryParams.append("page", value);
    queryParams.append("limit", pageSize); // Assuming pageSize is the number of items per page

    // Call the API with the query params
    await fetchPDIs(queryParams.toString());
  };

  const handlePageSizeChange = async (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add the new page and page size to the query params
    queryParams.append("page", 1);
    queryParams.append("limit", newSize);
    await fetchPDIs(queryParams.toString());
  };

  const handleApprove = async (id, pdiDoneBy) => {
    console.log("Approving PDI with ID:", id, "PDI Done By:", pdiDoneBy);
    setLoading(id);
    try {
      let url = `${serverURL}/PDI/approve/${id}`;
      if (selectedRow.purchaseOrderId) {
        url = `${serverURL}/PDI/approvePurchaseOrderPDI/${id}`;
      }
      const response = await axios.put(
        url,
        { pdiDoneBy },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.status === 200) {
        getPDITableData(); // Refresh data after action
      }
    } catch (error) {
      console.error("Error approving PDI:", error.message);
    } finally {
      setLoading(null);
    }
  };

  const handleReject = async (id, rejectionReason, pdiDoneBy) => {
    setLoading(id);
    try {
      const response = await axios.put(
        `${serverURL}/pdi/reject/${id}`,
        { rejectionReason, pdiDoneBy },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.status === 200) {
        getPDITableData(); // Refresh data after action
      }
    } catch (error) {
      console.error("Error rejecting PDI:", error.message);
    } finally {
      setLoading(null);
    }
  };

  // Handle open modal
  const handleCheckListOpenModal = (document) => {
    setSelectedDocument(document);
    setCheckListOpenModal(true);
  };

  const fetchPDIs = async (queryParams) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${serverURL}/PDI?${queryParams}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response?.data?.success) {
        setTotalPages(response?.data?.totalPages);
        setPDI(response?.data?.data);
        setPage(response?.data?.currentPage);
      }
    } catch (error) {
      console.error("Error fetching filtered vendors:", error);
    } finally {
    }
  };

  const handleSearchChangeHead = (e, key) => {
    const value = e.target.value.toLowerCase();

    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      // Clear any existing timeout
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      // Check if all search fields are empty, reset to full API fetch
      const allFieldsEmpty = Object.values(updatedInputs).every(
        (val) => val.trim() === "",
      );

      if (allFieldsEmpty) {
        getPDITableData(1, pageSize);
        return updatedInputs;
      }

      // Set a new timeout for the API call
      const newTimeout = setTimeout(() => {
        const queryParams = new URLSearchParams();

        // Only include non-empty search parameters
        Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
          if (searchValue.trim() !== "") {
            queryParams.append(searchKey, searchValue);
          }
        });

        // Add pagination parameters
        queryParams.append("page", 1);
        queryParams.append("limit", pageSize);

        // Make the API call with debounced parameters
        fetchPDIs(queryParams.toString());
      }, 3000); // 300ms debounce delay

      setDebounceTimeout(newTimeout);

      return updatedInputs;
    });
  };

  // Handle close modal
  const handleCheckListCloseModal = () => {
    setCheckListOpenModal(false);
    setSelectedDocument(null);
  };

  // Function to generate and download PDF from the modal content
  const handleDownloadPdf = () => {
    if (!selectedDocument) return;

    const doc = new jsPDF();

    // Add content to the PDF (from the modal content)
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);

    doc.text(
      `Campaign Title: ${selectedDocument.campaignTitle || "Not Available"}`,
      10,
      10,
    );
    doc.text(
      `Batch ID: ${selectedDocument?.batchId?._id || "Not Available"}`,
      10,
      20,
    );
    doc.text(
      `PDI Date: ${selectedDocument.pdiDate || "Not Available"}`,
      10,
      30,
    );
    doc.text(
      `PDI Done By: ${selectedDocument.pdiDoneBy || "Not Available"}`,
      10,
      40,
    );
    doc.text(
      `Vendor Details: ${selectedDocument.vendorDetails || "Not Available"}`,
      10,
      50,
    );
    doc.text(
      `Vendor Address: ${selectedDocument.vendorAddress || "Not Available"}`,
      10,
      60,
    );
    doc.text(
      `Upload Document: ${selectedDocument.uploadDocument || "Not Available"}`,
      10,
      70,
    );
    doc.text(
      `Require to Check: ${selectedDocument.requireToCheck ? "Yes" : "No"}`,
      10,
      80,
    );
    doc.text(
      `PDI Status: ${selectedDocument.pdiStatus || "Not Available"}`,
      10,
      90,
    );

    // Download the PDF
    doc.save(`${selectedDocument.campaignTitle || "document"}.pdf`);
  };

  const handleFileChange = async (e, id) => {
    const file = e.target.files[0];

    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error", // Type of alert
          title: "File Too Large",
          text: "The file size exceeds the maximum limit of 2MB. Please upload a smaller file.",
          confirmButtonText: "OK",
        });

        return;
      }

      const formDataNew = new FormData();
      formDataNew.append("files", file);

      try {
        const token = localStorage.getItem("token");
        const uploadResponse = await axios.post(
          `${process.env.REACT_APP_URL}/upload`,
          formDataNew,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (uploadResponse.data.success) {
          setSelectedFiles((prev) => ({
            ...prev,
            [id]: { file, fileName: file.name }, // Store by ID
          }));
          const response = await axios.put(
            `${serverURL}/PDI/edit/${id}`,
            {
              uploadDocument: uploadResponse.data.data[0],
              checkForUpload: true,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          getPDITableData(1, pageSize);
        }
      } catch (error) {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error", // Type of alert
          text: "Error during upload File.",
          confirmButtonText: "OK",
        });

        console.error("Error during upload or patch process", error);
      }
    }
  };

  const handleFileOpen = (fileUrl) => {
    setSelectedFile(fileUrl);
    setIsFileOpen(true);
  };

  const handleFileClose = () => {
    setIsFileOpen(false);
    setSelectedFile(null);
  };

  return (
    <div className="bg-white h-full">
      <Box>
        {!installationPartnerListLoading ? (
          <Paper
            sx={{ width: "100%", boxShadow: "none" }}
            className={styles.tableGap}
          >
            <EnhancedTableToolbar
              userVenderData={getPDITableData}
              totalInstallationPartner={totalInstallationPartner}
              // setSearchInputs={setSearchInputs} // Function to update search inputs
              // handleSearchChangeHead={handleSearchChangeHead}
              // searchInputs={searchInputs}
            />
            <>
              <TableContainer
                className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
              >
                <Table
                  stickyHeader
                  // sx={{ minWidth: 750 }}
                  className="rounded-lg "
                >
                  <EnhancedTableHead
                    rowCount={PDI.length}
                    userListData={getPDITableData}
                    setSearchInputs={setSearchInputs}
                    handleSearchChangeHead={handleSearchChangeHead}
                    searchInputs={searchInputs}
                  />
                  {PDI && PDI?.length > 0 ? (
                    <TableBody>
                      {PDI.map((v, index) => {
                        return (
                          <TableRow
                            tabIndex={-1}
                            key={index}
                            className={styles.tableRowHead}
                          >
                            <TableCell
                              className={styles.tableRow}
                              sx={{
                                wordWrap: "break-word",
                                whiteSpace: "normal",
                                textAlign: "left",

                                py: 1,
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  textAlign: "left",
                                  wordBreak: "break-word",
                                }}
                              >
                                {(v?.campaignTitle &&
                                  v?.campaignTitle?.charAt(0)?.toUpperCase() +
                                    v?.campaignTitle?.slice(1)) ??
                                  "Not Available"}
                              </span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="flex flex-col">
                                <span>
                                  {v?.batchId?.batchTitle || "Not Available"}
                                </span>
                                <span className="text-gray-400 text-xs">
                                  {v?.batchId?._id
                                    ? `#${v.batchId._id.slice(-6)}`
                                    : "Not Available"}
                                </span>
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              <span>
                                <FormatTimestamp timestamp={v.pdiDate} />
                              </span>
                            </TableCell>
                            <TableCell
                              className={styles.tableRow}
                              style={{ verticalAlign: "top" }}
                            >
                              <div className="flex flex-col p-2">
                                <span className="inline-block ">
                                  {v?.vendorId?.vendorBusinessName
                                    ? v?.vendorId?.vendorBusinessName
                                        .split(" ")
                                        .map(
                                          (ele) =>
                                            ele.charAt(0).toUpperCase() +
                                            ele.slice(1),
                                        )
                                        .join(" ")
                                    : "NA"}
                                </span>
                                <span className="text-gray-400 text-xs">
                                  {v?.vendorId?.address ?? "NA"}
                                </span>
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-center">
                                <IconButton
                                  onClick={() => handleCheckListOpenModal(v)} // On click, open modal with document details
                                >
                                  <PictureAsPdf
                                    color="primary"
                                    className="transition-transform duration-300 ease-in-out transform hover:scale-125"
                                  />
                                </IconButton>
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {/* <button
                                onClick={() => {
                                  setSelectedProductMedia(
                                    v?.pdiImagesOfProducts || [],
                                  );
                                  setIsMediaModalOpen(true);
                                }}
                                className="rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
                              ></button> */}
                              <div className="w-36">
                                <GlobalButton
                                  type="submit"
                                  variant="primary"
                                  size="medium"
                                  onClick={() => {
                                    setSelectedProductMedia(
                                      v?.pdiImagesOfProducts || [],
                                    );
                                    setIsMediaModalOpen(true);
                                  }}
                                >
                                  View Product Media
                                </GlobalButton>
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              <PDIAssignmentModal
                                pdiData={v}
                                getPDIList={getPDITableData}
                                initialpdiAssignedTo={v.pdiAssignedTo}
                                users={keyAccountManagers}
                                onChange={getPDITableData}
                              />
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {v.pdiStatus === "Requested" ? (
                                <div className="flex">
                                  <GlobalButton
                                    variant="primary"
                                    size="medium"
                                    onClick={() => {
                                      setSelectedRow(v);
                                      setApproveDialogOpen(true);
                                    }}
                                    style={{ marginRight: "8px" }}
                                    disabled={loading === v._id}
                                    isLoading={loading === v._id}
                                  >
                                    {`Approve`}
                                  </GlobalButton>
                                  <GlobalButton
                                    variant="secondary"
                                    size="medium"
                                    onClick={() => {
                                      setSelectedRow(v);
                                      setDialogOpen(true);
                                    }}
                                  >
                                    {`Reject`}
                                  </GlobalButton>
                                  <PDIApprovalDialog
                                    open={approveDialogOpen}
                                    onClose={() => setApproveDialogOpen(false)}
                                    onSubmit={(pdiDoneBy) => {
                                      handleApprove(selectedRow._id, pdiDoneBy);
                                    }}
                                    setApproveDialogOpen={setApproveDialogOpen}
                                  />

                                  <PDIRejectedDialog
                                    open={dialogOpen}
                                    onClose={() => setDialogOpen(false)}
                                    onSubmit={(rejectionReason, pdiDoneBy) =>
                                      handleReject(
                                        selectedRow._id,
                                        rejectionReason,
                                        pdiDoneBy,
                                      )
                                    }
                                  />
                                </div>
                              ) : v.pdiStatus === "Rejected" ? (
                                <>
                                  <p className="font-semibold flex items-center gap-1 pl-2">
                                    <span>
                                      <BlockIcon
                                        color="error"
                                        fontSize="small"
                                      />
                                    </span>
                                    <span className="text-[var(--error-color)] text-[12px]">
                                      Reject
                                    </span>
                                    <span>
                                      <Tooltip title="Click to view reason">
                                        <IconButton
                                          onClick={() => {
                                            setSelectedReason(
                                              v?.rejectionReason,
                                            );
                                            setReasonDialogOpen(true);
                                          }}
                                        >
                                          <MoreVert fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    </span>
                                  </p>
                                  <PDIReasonDialog
                                    open={reasonDialogOpen}
                                    onClose={() => setReasonDialogOpen(false)}
                                    reason={selectedReason} // Ensure it's never undefined
                                  />
                                </>
                              ) : (
                                <Chip
                                  label="Approve"
                                  sx={{
                                    backgroundColor: "#DDFFD3", // Custom background color
                                    color: "#358C09", // Custom text color
                                    marginLeft: 1,
                                  }}
                                />
                              )}
                            </TableCell>

                            <TableCell
                              className={styles.tableRow}
                              sx={{
                                minWidth: 160, // Match the width defined in headCells
                                maxWidth: 160, // Constrain maximum width
                                wordWrap: "break-word",
                                whiteSpace: "normal",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  maxWidth: "100%",
                                  textAlign: "left",
                                  wordBreak: "break-word",
                                }}
                              >
                                {v.pdiDoneBy || "Not Available"}
                              </span>
                            </TableCell>

                            <TableCell
                              className={styles.tableRow}
                              sx={{
                                textAlign: "center",
                              }}
                            >
                              {v.pdiStatus === "Approved" ? (
                                v.uploadDocument ||
                                selectedFiles[v._id]?.fileName ? (
                                  <GlobalButton
                                    variant="primary"
                                    size="medium"
                                    onClick={() =>
                                      handleFileOpen(
                                        v.uploadDocument ||
                                          selectedFiles[v._id]?.fileName,
                                      )
                                    }
                                  >
                                    {`View PDF`}
                                  </GlobalButton>
                                ) : (
                                  <div>
                                    <GlobalButton
                                      variant="primary"
                                      size="medium"
                                      leftIcon={<NewPlusIcon />}
                                      onClick={() =>
                                        fileInputRef.current[v._id]?.click()
                                      } // Use ref instead of document.getElementById
                                    >
                                      {`Upload`}
                                    </GlobalButton>

                                    {/* Hidden File Input */}
                                    <input
                                      ref={(el) =>
                                        (fileInputRef.current[v._id] = el)
                                      } // Store ref dynamically
                                      type="file"
                                      accept="application/pdf"
                                      style={{ display: "none" }}
                                      onChange={(e) =>
                                        handleFileChange(e, v._id)
                                      }
                                    />
                                  </div>
                                )
                              ) : (
                                "Not Available"
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={headCells?.length}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          No PDI found
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </Table>

                <Dialog open={checkListOpenModal}>
                  <DialogTitle> 📄 PDI Document Details</DialogTitle>
                  <Tooltip title="Download PDF">
                    <IconButton
                      aria-label="close"
                      onClick={handleDownloadPdf}
                      sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                      })}
                    >
                      <CloudDownload />
                    </IconButton>
                  </Tooltip>
                  <DialogContent>
                    {selectedDocument ? (
                      <div className="w-full max-w-3xl mx-auto p-6 bg-gradient-to-br from-white via-gray-50 to-gray-100 rounded-2xl shadow-lg border border-gray-200 transition-all duration-300">
                        <div className="divide-y divide-gray-200 ">
                          {[
                            {
                              label: "Campaign Title",
                              value: selectedDocument?.campaignTitle,
                            },
                            {
                              label: "Batch ID",
                              value: `#${selectedDocument.batchId._id.slice(
                                0,
                                6,
                              )}`,
                            },
                            {
                              label: "PDI Date",
                              value: selectedDocument.pdiDate.slice(0, 10),
                            },
                            {
                              label: "PDI Done By",
                              value:
                                selectedDocument.pdiDoneBy || "Not Available",
                            },
                            {
                              label: "Vendor Details",
                              value:
                                selectedDocument?.vendorId?.vendorBusinessName,
                            },
                            {
                              label: "Vendor Address",
                              value: selectedDocument?.vendorId.address,
                            },
                            // {
                            //   label: "Upload Document",
                            //   value: selectedDocument.uploadDocument,
                            // },
                            {
                              label: "Require to Check",
                              value: selectedDocument?.requireToCheck
                                ? "Yes"
                                : "No",
                            },
                            {
                              label: "PDI Status",
                              value: selectedDocument?.pdiStatus,
                            },
                          ].map((item, index) => (
                            <div
                              key={index}
                              className="flex items-start gap-4 py-3 mb-1 px-4 rounded-md
               bg-gradient-to-r from-blue-300 to-indigo-50 hover:from-indigo-100 hover:to-blue-100
               transition-all duration-300 cursor-pointer"
                            >
                              {/* fixed label column */}
                              <strong className="w-40 text-gray-700 font-semibold">
                                {item.label}:
                              </strong>

                              {/* flexible value column, left aligned */}
                              <span className="flex-1 text-left text-gray-900 font-medium break-words">
                                {item.value}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <p className="text-center text-gray-500 italic mt-6">
                        No document selected.
                      </p>
                    )}
                  </DialogContent>
                  <DialogActions>
                    <GlobalButton
                      variant="secondary"
                      size="medium"
                      onClick={handleCheckListCloseModal}
                    >
                      {`Close`}
                    </GlobalButton>
                  </DialogActions>
                </Dialog>
              </TableContainer>
              <hr
                className="mt-2 bg-gray-200 "
                style={{ border: "0.5px solid var(--light-grey-color)" }}
              />

              <div className="flex items-center justify-between">
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                    "& .MuiInputBase-root:before": { borderBottom: "none" },
                    "& .MuiInputBase-root:after": { borderBottom: "none" },
                    "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                  }}
                >
                  <InputLabel
                    id="page-size-label"
                    sx={{
                      position: "static",
                      transform: "none",
                      fontSize: "14px",
                      marginRight: "8px",
                      marginTop: "2px",
                    }}
                  >
                    Rows
                  </InputLabel>
                  <Select
                    labelId="page-size-label"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Rows"
                  >
                    {pageSizeOptions.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Pagination
                  className="p-2 flex justify-center"
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#418cff", // Blue background for selected
                      color: "#fff", // White text for selected
                    },
                    "& .MuiPaginationItem-root.Mui-selected:hover": {
                      backgroundColor: "#3366cc", // Darker blue on hover
                    },
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#ddd", // Light gray for hovered items
                      },
                    },
                  }}
                />
              </div>
            </>
          </Paper>
        ) : (
          <div className={styles.tableLoading}>
            <CircularProgress />
          </div>
        )}
      </Box>
      <ProductMediaModal
        isOpen={isMediaModalOpen}
        onClose={() => setIsMediaModalOpen(false)}
        products={selectedProductMedia}
      />
      <FilePreviewModal
        open={isFileOpen}
        onClose={handleFileClose}
        fileUrl={selectedFile}
        maxWidth="800px"
        maxHeight="600px"
      />
    </div>
  );
}
